module.exports = __webpack_public_path__ + "static/media/Group3.00e98506.png";